import { render, staticRenderFns } from "./OutlinesButton.vue?vue&type=template&id=04f414f8&"
import script from "./OutlinesButton.vue?vue&type=script&lang=js&"
export * from "./OutlinesButton.vue?vue&type=script&lang=js&"
import style0 from "./OutlinesButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports